import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {
    BigintDeliverableDisplayDecimalPipe
} from '../../components/bigint-display-decimal-pipe/bigint-deliverable-display-decimal.pipe';
import {BigintDisplayDecimalPipe} from '../../components/bigint-display-decimal-pipe/bigint-display-decimal.pipe';
import {DisplayDecimalModule} from '../../components/display-decimal';
import {WIDGET_DESCRIPTIONS} from '../../components/layout/widget/widget-registry.service';
import {PartialLoadingIndicatorModule} from '../../components/partial-loading-indicator';
import {TooltipModule} from '../../components/tooltip/index';
import {L10nModule} from '../../components/translate';
import {AutofocusModule} from '../../directives/autofocus';
import {SparklineModule} from '../../mobile/pages/m-quotes-page/m-quotes-mini-chart/sparkline';
import {DynAuthWidgetBodyComponent} from '../components/dyn-auth-widget-body/dyn-auth-widget-body.component';
import {
    DexLpDetailsStandaloneComponent
} from '../dex-lp-widget/standalone/dex-lp-details-standalone/dex-lp-details-standalone.component';
import {DexTrancheSparklinePipe} from '../dex-tranche-details-widget/dex-tranche-sparkline.pipe';
import {DexLpDetailsTableComponent} from './dex-lp-details-table/dex-lp-details-table.component';
import {DexLpDetailsWidgetComponent} from './dex-lp-details-widget.component';
import {DEX_LP_DETAILS_WIDGET_DESCRIPTION} from './dex-lp-details-widget.description';
import {DexLpDetailsWidgetSettingsComponent} from './settings/dex-lp-details-widget-settings.component';
import {DexLpDetailsWidgetSettingsService} from './settings/dex-lp-details-widget-settings.service';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        L10nModule,
        AutofocusModule,
        PartialLoadingIndicatorModule,
        DynAuthWidgetBodyComponent,
        SparklineModule,
        DisplayDecimalModule,
        BigintDisplayDecimalPipe,
        DexLpDetailsTableComponent,
        BigintDeliverableDisplayDecimalPipe,
        DexTrancheSparklinePipe,
        TooltipModule,
        DexLpDetailsStandaloneComponent
    ],
    declarations: [
        DexLpDetailsWidgetComponent,
        DexLpDetailsWidgetSettingsComponent
    ],
    exports: [
        DexLpDetailsWidgetComponent
    ],
    providers: [
        DexLpDetailsWidgetSettingsService,
        {
            provide:  WIDGET_DESCRIPTIONS,
            useValue: DEX_LP_DETAILS_WIDGET_DESCRIPTION,
            multi:    true
        }
    ]
})
export class DexLpDetailsWidgetModule {}
